import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { ModalService } from './modal.service';

angular.module('app-lite.modals', [])
  .service('modalApi', downgradeInjectable(ModalService));

